import React, { useEffect, useRef, useState } from "react";
import PatientData from "./patientdata";
import logo from '../../assets/blinkscribelogo.png';
import redmic from '../../assets/redmic.png';
import { moon } from "./utils/svg";
import useModalStore from "zustand/zustandstore";
import ToastMessage from "utils/muialerts/righttoptoast";
import { Backdrop, CircularProgress } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faTrash } from "@fortawesome/free-solid-svg-icons";
import ReactiveWaves from "version2/visualizerv2";
import Addpatient from "version2/modals/addpatient";
import ProfileIcon from "../../assets/user-circle.svg";
import { useNavigate } from "react-router-dom";
const CareIq = ({setRosData,recentRecord,isuploadaudioflow,ui,isPaused,handleencounters,formatTime,audioStreamRef,getimgs,timelinedata,imgdata,isTimeLineLoading,
 rosdata, data,pausemanualRecording,isError,elapsedTime,togglePause,pausedref, setDeleteConfirmationModal,stopTimer,setExitModal,setIsPaused, selectedTemplate,selectedRecord,setIsuploadmodal,checkConsent,handleStartRecording,errorMessage,setErrorMessage,setDetailsModal,
  templates,setSelectedTemplate, setPatientId,patientName, patientid,setPatientName,isDetailsmoadal,setui,loguser}) => {
  const { careiqRecord,darkmode } = useModalStore();
;
 const [isOpen, setIsOpen] = useState(false);

  const mydata = useModalStore();
        const [loading,setLoading]=useState(false)
  const [open, setOpen] = useState(false);
    const [alertmessage, setAlertMessage] = useState('');
        const [severity, setSeverity] = useState('success');
 const[myimgurl,setMyimgUrl]=useState('')
     const menuRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate=useNavigate()

  const isDisabled = mydata?.usertype === 'PRO' && Object.keys(mydata?.selectedRecord || {}).length === 0;
       const toggleMenu = () => {
          setIsMenuOpen(!isMenuOpen);
      };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
   useEffect(() => {
              const handleClickOutside = (event) => {
                  if (menuRef.current && !menuRef.current.contains(event.target)) {
                      setIsMenuOpen(false); // Close menu
                  }
              };
      
              document.addEventListener("mousedown", handleClickOutside);
              return () => {
                  document.removeEventListener("mousedown", handleClickOutside);
              };
          }, [menuRef]);
  // Wait until patient is available
  if (!careiqRecord) {
    return <div className="p-4 text-gray-600">No patient selected.</div>;
  }

  const fileName = careiqRecord?.value?.match(/_(\d+)\.json$/)?.[1] || '';

  return (
    <div className="w-full p-4 [background:var(--careiq-bg,_linear-gradient(135deg,_var(--color-grey-95,_#E6EEFE)_0%,_var(--color-grey-97,_#F6F7F9)_50%,_var(--color-azure-8120,_rgba(161,_190,_252,_0.20))_100%))]">
      {/* Header */}
      
      <div className="flex justify-between items-center">
        <img src={logo} className="ml-12 w-[120px]" alt="Logo" />

        {ui==2?<><div className="flex w-full">  
     
        <div className="w-full mr-8 flex gap-4 items-center justify-end">
          <div className="flex gap-4 items-center">
        
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22" fill="none">
  <path d="M7.97192 2.5C7.68859 2.5 7.45126 2.404 7.25992 2.212C7.06859 2.02 6.97259 1.78267 6.97192 1.5C6.97126 1.21733 7.06726 0.98 7.25992 0.788C7.45259 0.596 7.68992 0.5 7.97192 0.5H11.9719C12.2553 0.5 12.4929 0.596 12.6849 0.788C12.8769 0.98 12.9726 1.21733 12.9719 1.5C12.9713 1.78267 12.8753 2.02033 12.6839 2.213C12.4926 2.40567 12.2553 2.50133 11.9719 2.5H7.97192ZM9.97192 13.5C10.2553 13.5 10.4929 13.404 10.6849 13.212C10.8769 13.02 10.9726 12.7827 10.9719 12.5V8.5C10.9719 8.21667 10.8759 7.97933 10.6839 7.788C10.4919 7.59667 10.2546 7.50067 9.97192 7.5C9.68926 7.49933 9.45192 7.59533 9.25992 7.788C9.06792 7.98067 8.97192 8.218 8.97192 8.5V12.5C8.97192 12.7833 9.06792 13.021 9.25992 13.213C9.45192 13.405 9.68926 13.5007 9.97192 13.5ZM9.97192 21.5C8.73859 21.5 7.57592 21.2627 6.48392 20.788C5.39192 20.3133 4.43792 19.6673 3.62192 18.85C2.80592 18.0327 2.16026 17.0783 1.68492 15.987C1.20959 14.8957 0.971924 13.7333 0.971924 12.5C0.971924 11.2667 1.20959 10.104 1.68492 9.012C2.16026 7.92 2.80592 6.966 3.62192 6.15C4.43792 5.334 5.39226 4.68833 6.48492 4.213C7.57759 3.73767 8.73992 3.5 9.97192 3.5C11.0053 3.5 11.9969 3.66667 12.9469 4C13.8969 4.33333 14.7886 4.81667 15.6219 5.45L16.3219 4.75C16.5053 4.56667 16.7386 4.475 17.0219 4.475C17.3053 4.475 17.5386 4.56667 17.7219 4.75C17.9053 4.93333 17.9969 5.16667 17.9969 5.45C17.9969 5.73333 17.9053 5.96667 17.7219 6.15L17.0219 6.85C17.6553 7.68333 18.1386 8.575 18.4719 9.525C18.8053 10.475 18.9719 11.4667 18.9719 12.5C18.9719 13.7333 18.7343 14.896 18.2589 15.988C17.7836 17.08 17.1379 18.034 16.3219 18.85C15.5059 19.666 14.5516 20.312 13.4589 20.788C12.3663 21.264 11.2039 21.5013 9.97192 21.5Z" fill="#2C5282"/>
</svg>
             
<div className="text-[#2C5282]">        {formatTime(elapsedTime)}s </div>

 <ReactiveWaves isPaused={!isPaused}  mediaStream={audioStreamRef.current}/>

          </div>

{!isPaused?<><div className="cursor-pointer" onClick={() => {
                togglePause()

               }}>

               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M0.166748 3.25C0.166748 1.75691 0.166748 1.01116 0.630665 0.547245C1.09458 0.0833282 1.84033 0.0833282 3.33342 0.0833282C4.8265 0.0833282 5.57225 0.0833282 6.03616 0.547245C6.50008 1.01116 6.50008 1.75691 6.50008 3.25V12.75C6.50008 14.2431 6.50008 14.9888 6.03616 15.4527C5.57225 15.9167 4.8265 15.9167 3.33342 15.9167C1.84033 15.9167 1.09458 15.9167 0.630665 15.4527C0.166748 14.9888 0.166748 14.2431 0.166748 12.75V3.25ZM9.66675 3.25C9.66675 1.75691 9.66675 1.01116 10.1307 0.547245C10.5946 0.0833282 11.3403 0.0833282 12.8334 0.0833282C14.3265 0.0833282 15.0722 0.0833282 15.5362 0.547245C16.0001 1.01116 16.0001 1.75691 16.0001 3.25V12.75C16.0001 14.2431 16.0001 14.9888 15.5362 15.4527C15.0722 15.9167 14.3265 15.9167 12.8334 15.9167C11.3403 15.9167 10.5946 15.9167 10.1307 15.4527C9.66675 14.9888 9.66675 14.2431 9.66675 12.75V3.25Z" fill="#2C5282"/>
</svg>
  </div></>:
<div className="cursor-pointer border-2 border-[#e5e5e56e] px-2 bg-[#FFF]"   onClick={() => {
                togglePause()
               }}>
  <FontAwesomeIcon icon={faPlay} />
</div>}
<div      onClick={()=> {
      if(!isPaused){
       stopTimer()
       pausedref.current=false
       setIsPaused(true)
       if(isError){
        pausemanualRecording()
       }
       
      }
      setExitModal(true)

             //   pauseRecording();
                                           
               }} className="border-2  cursor-pointer border-[#e5e5e56e] px-2 py-[5px] bg-[#FFF]">
<svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
               <path d="M0 13V3C0 2.3125 0.245 1.72417 0.735 1.235C1.225 0.745833 1.81333 0.500833 2.5 0.5H12.5C13.1875 0.5 13.7762 0.745 14.2662 1.235C14.7562 1.725 15.0008 2.31333 15 3V13C15 13.6875 14.7554 14.2762 14.2662 14.7662C13.7771 15.2562 13.1883 15.5008 12.5 15.5H2.5C1.8125 15.5 1.22417 15.2554 0.735 14.7662C0.245833 14.2771 0.000833333 13.6883 0 13Z" fill="#2C5282"/>
             </svg>
</div>

<div className="text-red-500 cursor-pointer"
onClick={() => {
    if(!pausedref.current){
      stopTimer()
      setIsPaused(true)
      pausedref.current=false              
     
     }
 setDeleteConfirmationModal(true)
  }}
>
<FontAwesomeIcon icon={faTrash}  />

</div>

        </div>


    </div></>:
    <div       onClick={(e)=>{
 e.stopPropagation()
 isuploadaudioflow.current=false  
 
    setRosData('')
    checkConsent()

  }}>

<img
  
          src={redmic}
          alt="Red Mic"
          className="w-12 cursor-pointer shadow-md rounded-full"
        />

    </div>
    }
<div className="flex items-center gap-4">
  {/* <div
          className="inline-flex items-center justify-center p-2"
          style={{
            borderRadius: '8.75px',
            background: 'rgba(255, 255, 255, 0.7)',
            boxShadow: '0 0 4px rgba(0, 0, 0, 0.25)',
            backdropFilter: 'blur(3px)',
            WebkitBackdropFilter: 'blur(3px)',
          }}
        >
          {moon}
        </div> */}
         <div className="cursor-pointer" onClick={()=>toggleMenu()}>

    <img src={ProfileIcon}      
            className="h-5 sm:h-6 cursor-pointer" />
</div> 
</div>
        
                     {isMenuOpen && (
            <div
              ref={menuRef}
              className="absolute right-4 top-12 mt-6 bg-white border border-gray-200 rounded-lg shadow-lg z-10 w-36 max-w-auto"
            >
              <ul className="py-2">
             
                <li
                  onClick={() => {
                    setIsMenuOpen(!isMenuOpen);
                   
                    localStorage.removeItem('mytab')
                    sessionStorage.removeItem('auth');
                 
                    navigate('/auth1');
                  }}
                  className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer text-left"
                >
                  Logout
                </li>
              </ul>
            </div>
          )}
      </div>

      {/* Patient data */}
      <div className="w-full mt-6">
        <PatientData
        recentRecord={recentRecord}
          patientid={careiqRecord?.id || ''}
          fileName={fileName}
          data={careiqRecord?.content}
          setui={setui}
        />
      </div>
      

      <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
    <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" size={40} />
      </Backdrop>
    </div>
  );
};

export default CareIq;
